var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText("upload_file.list_title", "檔案管理")) + " ")]), _c('div', {
    staticClass: "\n          col-12 col-xl-8\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.FILE_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'UploadFileCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.creat_upload_file", "新增檔案")))]) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.displayText('upload_file.search_placeholder', '搜尋檔案名稱')
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("upload_file.advanced_search", "進階搜尋")) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.displayText('upload_file.search_placeholder', '搜尋檔案名稱')
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row mt-2"
  }, [_c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates,
      "startedPlaceholder": _vm.displayText('upload_file.search_started_placeholder', 'Start Date'),
      "endedPlaceholder": _vm.displayText('upload_file.search_ended_placeholder', 'End Date')
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row mt-2"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('upload_file.field_type', '檔案類型'),
      "label-cols-sm": "1",
      "content-cols-sm": "",
      "content-cols-lg": "11"
    }
  }, [_c('b-form-checkbox-group', {
    staticClass: "pt-1",
    attrs: {
      "id": "extension-selected",
      "options": _vm.extensionOptions
    },
    model: {
      value: _vm.query.extension,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "extension", $$v);
      },
      expression: "query.extension"
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex-column mt-2"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.reset_search_title", "重置搜尋條件")))]), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.search_title", "搜尋")))])], 1)])], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.uploadFiles,
      "fields": _vm.fields,
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(info)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-start align-items-center m-auto"
        }, [data.item.file.extension ? _c('div', {
          staticClass: "mr-2 w-50"
        }, [_vm._v(" " + _vm._s(data.item.file.extension.toUpperCase()) + " ")]) : _vm._e(), _c('div', {
          staticClass: "flex-fill"
        }, [!_vm.getModuleConfig('upload_files', 'list.hide_file_url') ? _c('button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.file_url,
            expression: "data.item.file_url",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: _vm.displayText('upload_file.copy_success', '已複製'),
            expression: "\n                          displayText('upload_file.copy_success', '已複製')\n                      ",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "btn btn-inverse-dark",
          attrs: {
            "type": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-files-o"
        })]) : _vm._e(), !_vm.getModuleConfig('upload_files', 'list.hide_liff_url') ? _c('button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.liff_url,
            expression: "data.item.liff_url",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: _vm.displayText('upload_file.copy_success', '已複製'),
            expression: "\n                          displayText('upload_file.copy_success', '已複製')\n                      ",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "btn mr-3 btn-inverse-dark",
          attrs: {
            "type": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-link"
        })]) : _vm._e()])])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.FILE_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'UploadFileView',
              params: {
                upload_file_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.view_text", "查看")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.FILE_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'UploadFileEdit',
              params: {
                upload_file_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.edit_text", "編輯")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.FILE_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteUploadFile(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("upload_file.delete_text", "刪除")) + " ")]) : _vm._e()];
      }
    }, {
      key: "empty",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted"
        }, [_c('p', [_vm._v("查無資料")])])];
      },
      proxy: true
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }